import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './topic-type.scss';

function TopicTypeItem(props) {
    const { title, list, style = {}, onDetail} = props;

    return <div style={style}>
        {title && <h4 className="title">
            {title}
        </h4>}
        <ul className="topic-type-dropdown-menu">
            {list.map((item, index) => {
                return <div key={index} style={{paddingBottom: 5}}>
                    <li className="item" onClick={() => onDetail(item)}>
                        {item.name} <img className={classNames('icon')} src={'/img/chevron_right.png'} alt=""/>
                    </li>
                </div>
            })}
        </ul>
    </div>
}


TopicTypeItem.propTypes = {
    list: PropTypes.array,
};

TopicTypeItem.defaultProps = {
    list: [],
};

export default TopicTypeItem;
